import { render, staticRenderFns } from "./OfertPage.vue?vue&type=template&id=61ed9ac9&scoped=true"
import script from "./OfertPage.vue?vue&type=script&lang=js"
export * from "./OfertPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed9ac9",
  null
  
)

export default component.exports